// Reducer
const showRefState = {
    selectedReferenceData: undefined,
    pdfPrintData: '',
    scrollPosition: 0
}

export default function showRefInfo(state = showRefState, action) {
    switch (action.type) {
        case 'SET_SELECTED_REFERENCE_DATA':
            return { ...state, selectedReferenceData: action.payload }
        case 'SET_PDF_PRINT_DATA':
            return { ...state, pdfPrintData: action.payload }
        case 'SET_SELECTED_SCROLL_POS':
            return { ...state, scrollPosition: action.payload }
        default:
            return state;

    }
}

